export const versionInfo = {
  version : '1.0.0-ae9cc2c',
  buildDate : '2026-11-05T10:36:40.773Z',
  commitHash : 'ae9cc2c'
}